<template>
  <vx-card class="mt-base">
    <!-- ACTION SLOT -->
    <template slot="actions">
      <!-- <feather-icon
        icon="CheckIcon"
        @click="showPointsConversion(true)"
      ></feather-icon> -->
    </template>

    <!-- USER BIO -->
    <vs-row vs-type="flex" class="mb-4">
      <div class="vx-card__title mb-4">
        <h4 class="mb-4 text-primary">Your registration is successful!</h4>
        <vs-col vs-w="7">
          <p>
            Note: Please check your mailbox (including spam/junk folders) for
            further instructions about your application. If you did not find the
            email, please contact us at support@worldpos.com.my.
          </p>
        </vs-col>
      </div>
    </vs-row>

    <vs-divider></vs-divider>

    <vs-row class="mb-4">
      <vs-col vs-w="3">
        <h6 class="text-grey">Registration Summary</h6>
      </vs-col>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Company Name</h6>
          <p>
            {{
              merchantDetails.companyName != ""
                ? merchantDetails.companyName
                : "(empty)"
            }}
          </p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Company ROC No.</h6>
          <p>
            {{
              merchantDetails.companyROCNo != ""
                ? merchantDetails.companyROCNo
                : "(empty)"
            }}
          </p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Brand Name</h6>
          <p>
            {{
              merchantDetails.brandName != ""
                ? merchantDetails.brandName
                : "(empty)"
            }}
          </p>
        </div>
      </div>

      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Brand Description</h6>
          <p>
            {{
              merchantDetails.brandDesc != ""
                ? merchantDetails.brandDesc
                : "(empty)"
            }}
          </p>
        </div>
      </div>

    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Owner Name</h6>
          <p>
            {{
              merchantDetails.ownerName != ""
                ? merchantDetails.ownerName
                : "(empty)"
            }}
          </p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Owner Contact No.</h6>
          <p>
            {{
              merchantDetails.ownerContactNo != ""
                ? merchantDetails.ownerContactNo
                : "(empty)"
            }}
          </p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>PIC Name</h6>
          <p>
            {{
              merchantDetails.picName != ""
                ? merchantDetails.picName
                : "(empty)"
            }}
          </p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>PIC Contact No.</h6>
          <p>
            {{
              merchantDetails.picContactNo != ""
                ? merchantDetails.picContactNo
                : "(empty)"
            }}
          </p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>PIC Designation</h6>
          <p>
            {{
              merchantDetails.picDesignation != ""
                ? merchantDetails.picDesignation
                : "(empty)"
            }}
          </p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>PIC Email</h6>
          <p>
            {{
              merchantDetails.picEmail != ""
                ? merchantDetails.picEmail
                : "(empty)"
            }}
          </p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Bank Name</h6>
          <p>
            {{
              merchantDetails.bankName != ""
                ? merchantDetails.bankName
                : "(empty)"
            }}
          </p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Account Name</h6>
          <p>
            {{
              merchantDetails.accountName != ""
                ? merchantDetails.accountName
                : "(empty)"
            }}
          </p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Account No</h6>
          <p>
            {{
              merchantDetails.accountNo != ""
                ? merchantDetails.accountNo
                : "(empty)"
            }}
          </p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Address 1</h6>
          <p>{{ merchantDetails.address1 != "" ? merchantDetails.address1 : "(empty)" }}</p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Address 2</h6>
          <p>{{ merchantDetails.address2 != "" ? merchantDetails.address2 : "(empty)" }}</p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Address 3</h6>
          <p>{{ merchantDetails.address3 != "" ? merchantDetails.address3 : "(empty)" }}</p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Address 4</h6>
          <p>{{ merchantDetails.address4 != "" ? merchantDetails.address4 : "(empty)" }}</p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Postcode</h6>
          <p>{{ merchantDetails.postcode != "" ? merchantDetails.postcode : "(empty)" }}</p>
        </div>
      </div>
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>State</h6>
          <p>{{ merchantDetails.state != "" ? getState() : "(empty)" }}</p>
        </div>
      </div>
    </vs-row>

    <vs-row class="mb-4">
      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Selected package</h6>
          <ul>
            <p v-if="merchantDetails.packages.length ==0">(empty)</p>
          <li v-else v-for="i in merchantDetails.packages" :key="i.id">{{i.isSelected ? i.name : ''}}<!-- {{i==merchantDetails.packages.length?'':', '}} --></li>
          </ul>
          <!-- <div v-for="i in merchantDetails.packages" :key="i.id">
            <p>{{ i.id }}</p>
          </div> -->
        </div>
      </div>

      <div class="vx-col md:w-1/2">
        <div class="flex flex-col">
          <h6>Salesperson ID</h6>
          <p>{{ merchantDetails.mcSalesManUid != "" ? merchantDetails.mcSalesManUid : "(empty)" }}</p>
        </div>
      </div>


    </vs-row>

    <!-- <div class="mt-5">
      <h6>Gift Cards Registered:</h6>
      <p>{{ registeredGiftcards }}</p>
    </div> -->
  </vx-card>
</template>
<script>
import mixin from "../mixin";
export default {
  mixins: [mixin],
  methods: {
    getState(){
      for(let i=0; i<this.statesList.length; i++){
        if(this.statesList[i].value == this.merchantDetails.state){
          return this.statesList[i].label;
        }
      }
    }
  },
  computed: {
    merchantDetails() {
      console.log(this.$store.state.giftcard.merchant);
      return this.$store.state.giftcard.merchant;
    },
    registeredGiftcards() {
      return this.$store.state.giftcard.giftcards.length;
    }
  }
};
</script>
